import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ArrowsArrowRightBoldIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M23.421 11.765L13.768.8C13.302.319 12.67.033 12 0c-.67.033-1.301.319-1.768.8L.579 11.765c-.343.378-.456.91-.295 1.395.16.484.57.844 1.07.942.5.098 1.015-.082 1.346-.47l7.45-8.466c.069-.078.179-.105.276-.068.097.037.161.13.161.234v17.255c0 .78.633 1.413 1.413 1.413s1.413-.633 1.413-1.413V5.332c0-.104.064-.197.162-.234.097-.037.207-.01.276.069l7.449 8.465c.331.388.845.568 1.346.47.5-.098.91-.458 1.07-.942.16-.484.048-1.017-.295-1.395z" transform="matrix(0 -1 -1 0 24 24)"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ArrowsArrowRightBoldIcon = __decorateClass([
  customElement("elm-arrows-arrow-right-bold-icon")
], ArrowsArrowRightBoldIcon);
export { ArrowsArrowRightBoldIcon };
